{
  "title": "Spirit Shroud",
  "source": "Tasha's Cauldron of Everything",
  "levelAndSchool": "3rd-level necromancy",
  "level": 3,
  "castingTime": "1 bonus action",
  "range": "Self",
  "components": "V, S",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "You call forth spirits of the dead, which flit around you for the spell’s duration. The spirits are intangible and invulnerable.",
    "Until the spell ends, any attack you make deals 1d8 extra damage when you hit a creature within 10 feet of you. This damage is radiant, necrotic, or cold (your choice when you cast the spell). Any creature that takes this damage can’t regain hit points until the start of your next turn.",
    "In addition, any creature of your choice that you can see that starts its turn within 10 feet of you has its speed reduced by 10 feet until the start of your next turn.",
    "At Higher Levels. When you cast this spell using a spell slot of 4th level or higher, the damage increases by 1d8 for every two slot levels above 3rd."
  ],
  "spellLists": ["cleric", "paladin", "warlock", "wizard"]
}
